module.exports = __webpack_public_path__ + "static/img/Charlie-Richardson.af2e0e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Richardson.jpg
// module id = CYm7
// module chunks = 0